.amwal-reset,
.amwal-reset *,
.amwal-reset *::before,
.amwal-reset *::after {
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    vertical-align: baseline !important;
    box-sizing: border-box !important;
    background: transparent !important;
    text-decoration: none !important;
    list-style: none !important;
    outline: none !important;
    -webkit-tap-highlight-color: transparent !important;
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
    font-size: 100% !important;
    font-weight: normal !important;
    font-style: normal !important;
    font-variant: normal !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    line-height: normal !important;
}

.amwal-widget-container {
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
    box-sizing: border-box !important;
    position: relative !important;
    font-size: 16px !important;
    font-weight: normal !important;
    font-style: normal !important;
    line-height: 1.4 !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-shadow: none !important;
    color: #222 !important;
}

.amwal-widget-container,
.amwal-widget-container * {
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
}

.amwal-promo,
.amwal-promo * {
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
}

.amwal-widget-container.show-badge::before {
    position: absolute !important;
    top: -8px !important;
    background: linear-gradient(135deg, #F4C542, #E8A91F) !important;
    color: #333 !important;
    padding: 4px 12px !important;
    border-radius: 12px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    z-index: 1001 !important;
    box-shadow: 0 2px 4px rgba(255, 215, 0, 0.4) !important;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.1) !important;
    white-space: nowrap !important;
}

.amwal-widget-container:not([dir="rtl"]).show-badge::before {
    content: "Sharia Compliant" !important;
    left: 12px !important;
}

.amwal-widget-container[dir="rtl"].show-badge::before {
    content: "متوافق مع الشريعة" !important;
    right: 12px !important;
    left: auto !important;
}

.amwal-promo {
    all: initial !important;
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
    cursor: pointer !important;
    box-sizing: border-box !important;
    position: relative !important;
    padding: 14px 18px !important;
    border-radius: 10px !important;
    border: 1px solid #e1e5e9 !important;
    background: #fff !important;
    color: #222 !important;
    min-width: 270px !important;
    max-width: min(600px, 90vw) !important;
    margin: 10px 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    z-index: 1000 !important;
    transition: all 0.2s ease !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
    text-align: left !important;
    direction: ltr !important;
    font-size: 16px !important;
    font-weight: normal !important;
    font-style: normal !important;
    line-height: 1.4 !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-shadow: none !important;
    text-decoration: none !important;
}

.amwal-promo[dir="rtl"] {
    direction: rtl !important;
    text-align: right !important;
}

.amwal-promo:hover {
    border-color: #000 !important;
    transform: translateY(-1px) !important;
}

.amwal-promo.green-border:hover {
    border-color: #000 !important;
}

.amwal-promo.green-border::after {
    position: absolute !important;
    top: -6px !important;
    background: #229E57 !important;
    color: white !important;
    padding: 3px 8px !important;
    border-radius: 8px !important;
    font-size: 9px !important;
    font-weight: 600 !important;
    box-shadow: 0 1px 3px rgba(0, 200, 81, 0.3) !important;
    z-index: 1 !important;
    white-space: nowrap !important;
}

.amwal-promo:not([dir="rtl"]).green-border::after {
    content: "0% Interest" !important;
    right: -6px !important;
}

.amwal-promo[dir="rtl"].green-border::after {
    content: "فائدة 0%" !important;
    left: -6px !important;
    right: auto !important;
}

.amwal-logo {
    position: static !important;
    width: 68px !important;
    height: auto !important;
    flex-shrink: 0 !important;
    margin-inline-end: 14px !important;
}

.amwal-promo[dir="rtl"] .amwal-logo {
    margin-inline-end: 0 !important;
    margin-inline-start: 14px !important;
    order: 2 !important;
}

.amwal-promo-content {
    display: flex !important;
    align-items: center !important;
    flex-grow: 1 !important;
    font-family: inherit !important;
    direction: inherit !important;
}

.amwal-promo[dir="rtl"] .amwal-promo-content {
    flex-direction: row-reverse !important;
}

.amwal-promo-text {
    font-weight: 600 !important;
    font-size: 16px !important;
    color: #222 !important;
    line-height: 1.4 !important;
    direction: inherit !important;
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
    font-style: normal !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-shadow: none !important;
    text-decoration: none !important;
}

.amwal-promo-text-container {
    display: flex !important;
    flex-direction: column !important;
    gap: 2px !important;
    flex-grow: 1 !important;
    direction: inherit !important;
}

.amwal-promo[dir="rtl"] .amwal-promo-text-container {
    text-align: right !important;
    margin-right: 15px !important;
}

.amwal-installments-count {
    font-weight: 700 !important;
    font-size: 16px !important;
    color: #4666f5 !important;
    /* Enhanced isolation */
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
    font-style: normal !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-shadow: none !important;
    text-decoration: none !important;
    line-height: 1.4 !important;
}
.amwal-link {
    color: #4666f5 !important;
    text-decoration: underline !important;
    font-size: 16px !important;
    white-space: nowrap !important;
    font-weight: 600 !important;
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
    font-style: normal !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-shadow: none !important;
    line-height: 1.4 !important;
}

.amwal-monthly-payment {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #666 !important;
    margin-top: 2px !important;
    display: inline-block !important;
    direction: inherit !important;
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
    font-style: normal !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-shadow: none !important;
    text-decoration: none !important;
    line-height: 1.4 !important;
}

.amwal-savings-text {
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #00c851 !important;
    margin-top: 2px !important;
    display: inline-block !important;
    direction: inherit !important;
    background-color: #e6f9e6 !important;
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
    font-style: normal !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-shadow: none !important;
    text-decoration: none !important;
    line-height: 1.4 !important;
}

.amwal-payment-savings-container {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    margin-top: 2px !important;
    direction: inherit !important;
    flex-wrap: wrap !important;
}

.amwal-widget-container[dir="rtl"] .amwal-payment-savings-container {
    flex-direction: row !important;
}

.amwal-promo.loading {
    opacity: 0.7 !important;
    pointer-events: none !important;
    cursor: default !important;
}

.amwal-social-proof {
    font-size: 12px !important;
    color: #999 !important;
    font-family: 'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Segoe UI Arabic', 'Noto Sans Arabic', 'Tahoma', sans-serif !important;
    font-weight: normal !important;
    font-style: normal !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-shadow: none !important;
    text-decoration: none !important;
    line-height: 1.4 !important;
}

@media only screen and (max-width: 768px) {
    .amwal-promo {
        max-width: 100% !important;
        padding: 12px 15px !important;
        width: 100% !important;
        margin: 8px 0 !important;
        min-width: 280px !important;
    }

    .amwal-logo {
        width: 60px !important;
        margin-inline-end: 12px !important;
    }

    .amwal-promo[dir="rtl"] .amwal-logo {
        margin-inline-start: 12px !important;
    }

    .amwal-promo-text {
        font-size: 14px !important;
        margin-top: 5px !important;
    }

    .amwal-installments-count {
        font-size: 14px !important;
    }

    .amwal-link {
        font-size: 14px !important;
    }

    .amwal-monthly-payment {
        font-size: 12px !important;
    }

    .amwal-savings-text {
        font-size: 11px !important;
    }
}

@media only screen and (max-width: 480px) {
    .amwal-promo {
        padding: 10px 12px !important;
        min-width: 260px !important;
    }

    .amwal-logo {
        width: 55px !important;
        margin-inline-end: 10px !important;
    }

    .amwal-promo[dir="rtl"] .amwal-logo {
        margin-inline-start: 10px !important;
    }

    .amwal-promo-text {
        font-size: 13px !important;
    }

    .amwal-installments-count {
        font-size: 13px !important;
    }

    .amwal-link {
        font-size: 13px !important;
    }

    .amwal-monthly-payment {
        font-size: 11px !important;
    }

    .amwal-savings-text {
        font-size: 10px !important;
    }

    .amwal-social-proof {
        font-size: 10px !important;
    }
}

@media (prefers-contrast: more) {
    .amwal-promo {
        border: 2px solid #000 !important;
        background: #fff !important;
        color: #000 !important;
    }

    .amwal-promo-text {
        color: #000 !important;
    }

    .amwal-link {
        color: #0000ff !important;
    }
}

@media (prefers-reduced-motion: reduce) {
    .amwal-promo {
        transition: none !important;
    }

    .amwal-promo:hover {
        transform: none !important;
    }
}

.amwal-widget-container,
.amwal-widget-container *,
.amwal-promo,
.amwal-promo * {
    text-transform: none !important;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-shadow: none !important;
    filter: none !important;
    opacity: 1 !important;
    visibility: visible !important;
    float: none !important;
    clear: none !important;
    z-index: 1 !important;
}

.amwal-widget-container[dir="rtl"] .amwal-installments-count,
.amwal-widget-container[dir="rtl"] .amwal-monthly-payment,
.amwal-widget-container[dir="rtl"] .amwal-savings-text {
    font-feature-settings: "lnum" 1 !important;
    unicode-bidi: embed !important;
}

.amwal-promo[dir="rtl"] .amwal-promo-text {
    unicode-bidi: embed !important;
    text-align: right !important;
}

.amwal-promo[dir="rtl"] .amwal-promo-text,
.amwal-promo[dir="rtl"] .amwal-monthly-payment,
.amwal-promo[dir="rtl"] .amwal-savings-text {
    word-spacing: 0.3em !important;
}